const igDonationContainer = document.querySelector('.membership')

if (igDonationContainer) {
  // amount page
  const amountPage = {}
  amountPage.paymentInformationContainer = igDonationContainer.querySelector('.payment-information')
  amountPage.directDebitContainer = igDonationContainer.querySelector('.payment-information .direct-debit')
  amountPage.amountContainer = igDonationContainer.querySelector('.amount-suggestions')
  amountPage.allAmountInputs = igDonationContainer.querySelectorAll('.amount-suggestions input[name=amount]')
  amountPage.customAmountInput = igDonationContainer.querySelector('.amount-suggestions input[name=custom-amount]')
  amountPage.allRhythmInputs = igDonationContainer.querySelectorAll('.rhythms input[name=rhythm]')
  amountPage.accountHolderField = igDonationContainer.querySelector('[name=account_holder]')
  amountPage.ibanField = igDonationContainer.querySelector('[name=iban]')
  amountPage.bicField = igDonationContainer.querySelector('[name=bic]')
  amountPage.allPaymentMethods = igDonationContainer.querySelectorAll('.payment-methods [name=payment_methods]')

  // personal data page
  const personalDataPage = {}
  personalDataPage.allInputs = window.pages[0].querySelectorAll('input, textarea')

  // confirmation page
  const confirmationPage = {}
  confirmationPage.allInputs = window.pages[2].querySelectorAll('input, textarea')

  // endpoints/urls
  const fullfillDonationUrl = igDonationContainer.getAttribute('data-fullfill-donation-endpoint')
  const thankYouUrl = igDonationContainer.getAttribute('data-thankyou-page')

  // constants
  const minimumDonationAmount = 6
  const loadingHTML = '<div class="spinner-border btn-red" role="status"></div>'

  // back button logic
  window.backButton.addEventListener('click', () => {
    window.goToStep(window.currentPage - 1)

    const position = window.getPos(window.pageIndicatorContainer)[1]
    window.scrollToSmoothly(position - 100, 1)
  })

  // next button logic
  window.nextButton.addEventListener('click', async () => {
    let pageIsValid = true
    let errorElement = null

    window.pages[window.currentPage].querySelectorAll('.required, .optional').forEach(
      element => {
        if (!element.classList.contains('is-valid')) {
          if (element.classList.contains('optional')) {
            if (element.value.length) {
              pageIsValid = false
              window.setFieldInvalid(element)
              if (!errorElement) errorElement = element
            }
          } else {
            pageIsValid = false
            window.setFieldInvalid(element)
            if (!errorElement) errorElement = element
          }
        }
      }
    )

    if (pageIsValid) {
      if (window.currentPage === 1) {
        // fill fields on the confirmation page with actual data.
        personalDataPage.allInputs.forEach(input => {
          if (input.value.length) {
            const confirmationElement = window.pages[2].querySelector(
              '[name=' + input.name + ']'
            )

            if (confirmationElement) {
              confirmationElement.value = input.value
              confirmationElement.parentElement.classList.remove('d-none')
            }
          }
        })

        // hide elements without content on the confirmation page.
        confirmationPage.allInputs.forEach(input => {
          if (!input.value) input.parentElement.classList.add('d-none')
        })
      }

      if (window.currentPage === 2) {
        const donationData = {
          amount: window.getDonationAmount(),
          rhythm: window.getDonationRhythm(false),
          project_id: igDonationContainer.getAttribute('data-project-id'),
          sepa_account_holder: amountPage.accountHolderField.value,
          sepa_iban: amountPage.ibanField.value,
          sepa_bic: amountPage.bicField.value,
          country: igDonationContainer.querySelector('[name=country]').value
        }

        personalDataPage.allInputs.forEach(input => {
          if (input.getAttribute('type') === 'checkbox') {
            donationData[input.name] = input.checked
          } else {
            if (input.value) {
              donationData[input.name] = input.value
            }
          }
        })

        window.nextButton.innerHTML = loadingHTML
        window.post(
          response => {
            response = JSON.parse(response)

            if (response.valid === true) {
              window.location = thankYouUrl
            }
          },
          fullfillDonationUrl,
          donationData
        )

        return
      }

      const position = window.getPos(window.pageIndicatorContainer)[1]
      window.scrollToSmoothly(position - 100, 1)

      window.goToStep(window.currentPage + 1)
    } else {
      const position = window.getPos(errorElement)[1]
      window.scrollToSmoothly(position - 100, 1)
    }
  })

  /*******************************************************
   * PAGE 0                                              *
   *******************************************************/

  // dataprotection validation
  igDonationContainer.querySelector('[name=data_protection_agreement]').addEventListener('change', event => {
    if (event.target.checked) {
      window.setFieldValid(
        event.target.parentElement
      )
    } else {
      window.setFieldInvalid(
        event.target.parentElement
      )
    }
  })

  // commitment to our goals validation
  igDonationContainer.querySelector('[name=i_commit]').addEventListener('change', event => {
    if (event.target.checked) {
      window.setFieldValid(
        event.target.parentElement
      )
    } else {
      window.setFieldInvalid(
        event.target.parentElement
      )
    }
  })

  // first name
  igDonationContainer.querySelector('[name=first_name]').addEventListener('change', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '2-100'
      }
    )
  })

  // date of birth - added condition because birthday should now displayed as 3 input fields (day, month, year)
  if(document.querySelector('[name=date_of_birth]')) {
    igDonationContainer.querySelector('[name=date_of_birth]').addEventListener('change', event => {
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'text',
          arguments: '10-10'
        }
      )
    })
  }

  // birthday day
  igDonationContainer.querySelector('[name=date_of_birth_day]').addEventListener('change', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'int',
        arguments: '1-31'
      }
    )
  })
  // birthday month
  igDonationContainer.querySelector('[name=date_of_birth_month]').addEventListener('change', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'int',
        arguments: '1-12'
      }
    )
  })
  // birthday month
  igDonationContainer.querySelector('[name=date_of_birth_year]').addEventListener('change', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'int',
        arguments: '1920-2003'
      }
    )
  })

  // last name
  igDonationContainer.querySelector('[name=last_name]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '2-100'
      }
    )
  )

  // street
  igDonationContainer.querySelector('[name=address]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '5-100'
      }
    )
  )

  // postcode
  igDonationContainer.querySelector('[name=postcode]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '1-100'
      }
    )
  )

  // city
  igDonationContainer.querySelector('[name=city]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '3-100'
      }
    )
  )

  // phone number
  igDonationContainer.querySelector('[name=phone].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'phone-number'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // fax
  igDonationContainer.querySelector('[name=fax].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'phone-number'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // acedemic title
  igDonationContainer.querySelector('[name=acedemic_title].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'text',
            arguments: '2-50'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // email
  igDonationContainer.querySelector('[name=email]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'email'
      }
    )
  )

  /*******************************************************
   * PAGE 0                                              *
   *******************************************************/

  // amount validation/logic
  amountPage.allAmountInputs.forEach(element => {
    element.addEventListener('change', event => {
      amountPage.customAmountInput.value = ''

      window.setFieldValid(
        amountPage.amountContainer
      )
    })
  })

  amountPage.customAmountInput.addEventListener('change', () => {
    amountPage.allAmountInputs.forEach(element => { element.checked = false })

    if (parseInt(amountPage.customAmountInput.value) >= minimumDonationAmount) {
      window.setFieldValid(
        amountPage.amountContainer
      )
    } else {
      window.setFieldInvalid(
        amountPage.amountContainer
      )
    }
  })

  // rhythm validation/logic
  amountPage.allRhythmInputs.forEach(input => {
    input.addEventListener('change', event => {
      const rhythmID = event.target.getAttribute('data-rhythm-key')

      switch (rhythmID) {
        // One time donation
        case 'E':
          window.definePossiblePaymentMethods({
            sepa_direct_debit: true,
            credit_card: true,
            paypal: true
          })
          break
        default:
          window.definePossiblePaymentMethods({
            sepa_direct_debit: true
          })
          break
      }

      window.setFieldValid(
        event.target.parentElement.parentElement
      )
    })
  })

  // payment method validation/logic
  amountPage.allPaymentMethods.forEach(element => {
    element.addEventListener('change', event => {
      window.setFieldValid(event.target.parentElement.parentElement)

      // reset states/appearance
      const enabledPaymentMethod = amountPage.paymentInformationContainer.querySelector('div.enabled')
      if (enabledPaymentMethod) enabledPaymentMethod.classList.remove('enabled')
      window.nextButton.innerText = window.nextButton.getAttribute('data-default')
      amountPage.accountHolderField.classList.remove('required', 'validation-error')
      amountPage.ibanField.classList.remove('required', 'validation-error')
      amountPage.bicField.classList.remove('required', 'validation-error')

      switch (event.target.getAttribute('data-payment-method')) {
        case 'sepa_direct_debit':
          amountPage.paymentInformationContainer.querySelector(
            '.direct-debit'
          ).classList.add('enabled')

          amountPage.accountHolderField.classList.add('required')
          amountPage.ibanField.classList.add('required')

          amountPage.accountHolderField.addEventListener('keyup', event => {
            window.waitUntilUserHasFinishedTypingAndValidateField(
              event.target,
              {
                type: 'text',
                arguments: '5-100'
              }
            )
          })

          amountPage.ibanField.addEventListener('keyup', event => {
            if (event.target.value.substring(0, 2).toUpperCase() === 'DE') {
              amountPage.bicField.parentElement.querySelector('label').classList.remove('required-indicator')
              amountPage.bicField.classList.remove('validation-error')
              amountPage.bicField.classList.remove('required')
            } else {
              amountPage.bicField.parentElement.querySelector('label').classList.add('required-indicator')
              amountPage.bicField.classList.add('required')
            }

            window.waitUntilUserHasFinishedTypingAndValidateField(
              event.target,
              {
                type: 'iban'
              }
            )
          })

          amountPage.bicField.addEventListener('keyup', event => {
            window.waitUntilUserHasFinishedTypingAndValidateField(
              event.target,
              {
                type: 'bic'
              }
            )
          })
          break
      }
    })
  })
}

// TODO: add confirm page
